export function YearBadge(props: { year: number }) {
    return (
        <div className="badge badge-lg badge-primary scale-125">
            {props.year}
        </div>
    );
}
